import { z } from 'zod'
import { EmailSchema, NameSchema } from '@/schemas'

export const userRoleEnum = z.enum([
  'SYSTEM_ADMIN',
  'DEVELOPER',
  'TREASURER',
  'PASTOR',
  'INVENTORY',
  'EXPENSES',
])

export const UserCreateSchema = z.object({
  email: EmailSchema,
  name: NameSchema,
  roles: z.array(userRoleEnum).min(1, 'At least one role is required'),
  churchId: z.array(z.string()).optional(),
  isAdminPastor: z.boolean().optional(),
})

export const UserUpdateSchema = UserCreateSchema.extend({
  _id: z.string(),
  active: z.boolean(),
})

export const UserSchema = UserUpdateSchema.extend({
  isVerified: z.boolean(),
  isTemporaryPassword: z.boolean(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  expireAt: z.date().optional(),
})

export type UserCreateData = z.infer<typeof UserCreateSchema>
export type UserUpdateData = z.infer<typeof UserUpdateSchema>
export type UserData = z.infer<typeof UserSchema>
